import { KeyboardEvent } from "react";
import PipelineHealthIcon from "@src/assets/icons/SidebarIcons/PipelineHealthIcon";
import { ItemContainer, ItemLabel } from "@src/components/Sidebar/Sidebar.styled";
import { PipelineHealthAlertCounts } from "./pipelineHealth.types";
import { formatAlertBreakdown } from "./pipelineHealthUtils";
import { CollapsedCountBadge, CountBadge, IconBadgeContainer, Row } from "./PipelineHealthIndicator.styled";

interface PipelineHealthIndicatorProps {
	alertCounts: PipelineHealthAlertCounts | null;
	loading: boolean;
	isExpanded: boolean;
	onClick: () => void;
}

const TOOLTIP_ID = "sidebar-tooltip";

export const PipelineHealthIndicator = ({ alertCounts, loading, isExpanded, onClick }: PipelineHealthIndicatorProps) => {
	const totalCount = alertCounts?.totalCount ?? 0;
	const hasAlerts = totalCount > 0;
	const breakdown = alertCounts ? formatAlertBreakdown(alertCounts) : loading ? "Loading" : "Unknown";
	const ariaLabel = `Pipeline health: ${breakdown}`;

	const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
		if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();
			onClick();
		}
	};

	if (!isExpanded) {
		return (
			<div data-tooltip-content={ariaLabel} data-tooltip-id={TOOLTIP_ID}>
				<ItemContainer
					$isActive={false}
					onClick={onClick}
					onKeyDown={handleKeyDown}
					role="button"
					tabIndex={0}
					aria-label={ariaLabel}>
					<IconBadgeContainer>
						<PipelineHealthIcon />
						<CollapsedCountBadge $hasAlerts={hasAlerts}>{totalCount}</CollapsedCountBadge>
					</IconBadgeContainer>
				</ItemContainer>
			</div>
		);
	}

	return (
		<div data-tooltip-content={ariaLabel} data-tooltip-id={TOOLTIP_ID}>
			<ItemContainer $isActive={false} onClick={onClick} onKeyDown={handleKeyDown} role="button" tabIndex={0} aria-label={ariaLabel}>
				<PipelineHealthIcon />
				<Row>
					<ItemLabel $isActive={false}>Pipeline health</ItemLabel>
					<CountBadge $hasAlerts={hasAlerts}>{totalCount}</CountBadge>
				</Row>
			</ItemContainer>
		</div>
	);
};
